import React from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";

const useStyles = makeStyles({
  travelTimeStyles: {
    "& span": {
      "&:first-of-type": {
        marginRight: "4px",
      },
    },
  },
});

const TravelTime = ({ label, value }) => {
  const { travelTimeStyles } = useStyles();
  return (
    <Box display="flex" className={travelTimeStyles}>
      <Typography variant="caption" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        <b>{value}</b>
      </Typography>
    </Box>
  );
};

export default TravelTime;
